export const ROW_OPTIONS = {
  EDIT: 'shared.types.tableRowOption.edit',
  DELETE: 'shared.types.tableRowOption.delete',
} as const;
